import React from 'react';
import './index.css';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ReactIndexedDB } from 'react-indexed-db';
import TallyList from './components/TallyList';

export const ListsContext = React.createContext();

class App extends React.Component {
  constructor() {
    super();

    this.db = new ReactIndexedDB('tallyCounter', 2);
    this.osName = 'app';

    this.state = {
      list: {
        name: 'Tally Counter',
        lastReset: new Date(),
        items: [
        ],
      },
      resetList: () => {
        let resetDateTime = new Date();

        let newData = [...this.state.list.items];
        for (let i = 0; i < this.state.list.items.length; i++) {
          newData[i].count = 0;
        }

        this.setState({
          list: Object.assign(
            this.state.list,
            {
              lastReset: resetDateTime,
              items: newData
            }
          ),
        });

        this.updateDb();
      },
      addItem: (name) => {
        let newData = [...this.state.list.items];
        newData.push({
          name: name,
          count: 0,
        });

        this.setState({
          list: Object.assign(
            this.state.list,
            {
              items: newData
            }
          ),
        });

        this.updateDb();
      },
      updateCount: (index, add) => {
        let newData = [...this.state.list.items];
        newData[index].count += add;

        this.setState({
          list: Object.assign(
            this.state.list,
            {
              items: newData
            }
          ),
        });

        this.updateDb();
      },
      editItem: (index, newName) => {
        let newData = [...this.state.list.items];
        newData[index].name = newName;

        this.setState({
          list: Object.assign(
            this.state.list,
            {
              items: newData
            }
          ),
        });

        this.updateDb();
      },
      removeItem: (index) => {
        let newData = [...this.state.list.items];
        newData.splice(index, 1);

        this.setState({
          list: Object.assign(
            this.state.list,
            {
              items: newData
            }
          ),
        });

        this.updateDb();
      },
    };
  }

  componentDidMount() {
    this.db.openDatabase(1, evt => {
      evt.currentTarget.result.createObjectStore(
        this.osName
      );
    }).then(
      () => {
        this.db.getByKey(this.osName, 1).then(
          data => {
            if (data != null) {
              this.setState({
                list: data
              });
            } else {
              this.db.add(this.osName, this.state.list, 1).catch(
                error => {
                  console.log(error);
                }
              );
            }
          },
          error => {
            console.log(error);
          }
        );
      },
      error => {
        console.log(error);
      }
    );
  }

  updateDb() {
    this.db.update(this.osName, this.state.list, 1).catch(
      error => {
        console.log(error);
      }
    );
  }

  render() {
    return (
      <ListsContext.Provider value={this.state}>
        <CssBaseline />
        <div className="app-main">
          <TallyList />
        </div>
      </ListsContext.Provider>
    );
  }
}

export default App;